<template>
  <div class="d-fliex justify-center" style="width: 100% !important;">
    <!-- start of USER-INPUT -->    
    <v-row class="mt-0" no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">  
            <v-form ref="form" class="mt-3">

            <!-- <v-form ref="loginForm" v-on:submit.prevent="login()" class="mt-3" v-model="valid" lazy-validation> -->

                <v-text-field color="black" dense class="mb-2" v-model.trim="userEmail" filled :background-color="inputBackgroundColor" :label="$t('fields.email')" append-icon="icons8-envelope" hide-details="auto" :rules="rules.email" required></v-text-field>
                <v-text-field dense class="mb-1" v-model.trim="userPassword" filled :background-color="inputBackgroundColor" :label="$t('fields.password')" :append-icon="show ? 'icons8-eye' : 'icons8-invisible'" :type="show ? 'text' : 'password'" 
                    @click:append="show = !show" 
                    :rules="rules.password"
                    hide-details="auto"
                    required
                    color="black"

                ></v-text-field>
                    <!-- v-on:keyup.enter="login()" -->
            </v-form>
        </v-col>
    </v-row>


    <v-row class="my-4">
        <v-col cols="6">
            <v-btn block depressed large @click="MIX_go('/register')" class="mt-3 grey lighten-1">{{ $t('buttons.register') }}</v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6">
            <!-- <v-btn class="primary mt-2 mb-1 white--text" style="width: 45% !important;" :large="largeButton" :small="smallButton" @click.native="login()">{{ $t('buttons.login') }}</v-btn>             -->
            <v-btn block depressed  :loading="loading" :disabled="loading" class="mt-3 darkgrey white--text" :large="largeButton" :small="smallButton" @click.native="validateForm()">{{ $t('buttons.login') }}</v-btn>
        </v-col>
    </v-row>

    <!-- end of USER-INPUT -->
  </div>
</template>

<script>
    import { mapActions } from 'vuex';
    export default {
        name: 'Login',
        data: () => ({
            inputBackgroundColor: 'white',
            valid: true,
            show: false,
            userEmail: '',
            userPassword: '',
            loading: false, // to show loading bar
            //validation rules
            rules: {}
            // emailRules: [
            //     (v) => !!v || 'E-mail is required',
            //     (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            // ],
            // passwordRules: [(v) => !!v || 'Password is required'],
        }),
        computed: {
            denseInput() {
                switch(true) {
                    case (this.$vuetify.breakpoint.xsOnly):
                        return true;
                    default:
                        return false;
                }
            },
            largeButton() {
                switch (true) {
                    case (this.$vuetify.breakpoint.xsOnly):
                        return false;
                    default:
                        return true;
                }
            },
            smallButton() {
                switch (true) {
                    case (this.$vuetify.breakpoint.xsOnly):
                        return true;
                    default:
                        return false;
                }
            }            
        },
        methods: {
            ...mapActions({
                ACT_currentUser: 'ACT_currentUser'
            }),
            checkCurrentUser(userID){
                let t = this;
                return new Promise(function (resolve) {
                    var currentUser = [];
                    t.$firebase.db.collection('users').doc(userID).get()
                        .then((doc) => {
                            if (doc.exists) { 
                                var document = doc.data();
                                document.id = doc.id;
                                currentUser = document;
                                resolve ({ code: 1, message: "Success Getting Current User Data", data: currentUser, error: null});
                            //console.log('doc exists')
                            } else {
                                currentUser = null;
                                resolve ({ code: -1, message: "Error couldnt find Current User", data: null, error: null });
                                t.MIX_alert(-1, 'Account not found.', null, null);
                            }
                        });
                })
            },
            login () {
                let t = this;
                t.MIX_progressBar({show: true});
                t.userEmail = t.userEmail.toLowerCase();
                // if (t.$refs.loginForm.validate()) {
                    t.$firebase.auth
                    .signInWithEmailAndPassword(t.userEmail, t.userPassword)
                    .then(async (data) => {
                        t.loading = true;
                        var user = await t.checkCurrentUser(data.user.uid);
                        //console.log('user = ' + JSON.stringify(user, null, 2))
                        if (user !== null){
                            // setTimeout(function(){            
                                t.MIX_progressBar({show: false}); 
                                t.MIX_FIREBASE_currentUser(data.user)
                                // TODO REMOVE this line
                                t.ACT_currentUser(user.data);
                                //this.$store.commit("SET_currentUser", data.user);

//                                setTimeout(function() {
                                    t.$router.push("/").catch(error => { 
                                            console.log(error.message)});
  //                                  },  1500);
                            // }, 500); 
                        }

                    })
                    .catch((err) => {
                        // console.log('err: ' + err)
                        t.MIX_alert(-1, err, null, null);
                    });
                // } else {
                //     t.MIX_alert(-1, 'The email password combination is incorrect.', null, null);
                // }
            },
            // * VALIDATION RULES
			validateForm() {
				let t = this;
                t.rules = {
                    email: [
                        (v) => !!v || 'E-mail is required',
                        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                    ],
                    password: [(v) => !!v || 'Password is required'],
                    // passName: [
                    //     v => !!v || 'Reason is required',
                    //     v => (v && v.length < 255) || 'Name must be less than 255 characters',
                    // ],
                    // site: [v => !!v || 'Required'],
                    // startDate: [v => !!v || "Day of First Visit Required"],
                    // endDate: [v => !!v || "Day of Last Visit Required"],
                    // noOfDays: [v => (v > 0 && v <= 7) || "Visitor Passes must be at least 1 Day and no more than 7 Days"],
                    // passHost: [v => !!v || 'TFW Sponsor is required'],
                    // organisation: [v => !!v || 'Organisation is required'],
                    // users: [v => JSON.stringify(v) !== '[]' || 'You must specify who the pass is required for'],
                    // status: [v => !!v || 'Status is required']
                }
                //let the DOM update
                t.$nextTick(() => {
                    //manually trigger Vuetify validation
                    if(t.$refs.form.validate()) {
                        //t.MIX_alert(1, "Passed validation.", null, null);
                        //it’s valid, do work
						// t.MIX_confirmBox (
                    	// 	{ 
                        // 		show: true,
                        // 		collection: 'passes/save',
                        // 		id: t.form.id,
                        // 		title: `Visitor Pass Declaration`, 
                        // 		description: `Please confirm that all Visitors listed on this pass are Medically fit to attend site and are not classed as vulnerable?`, 
                        // 		width: '300',
                        // 		height: '300',
                        // 		trueButtonText: 'Yes',
                        // 		trueButtonValue: 'YES',
                        // 		falseButtonText: 'No',
                        // 		falseButtonValue: 'NO',
      		            //   	}
			            // )      
                        //this.saveItem();
                        //console.log('continue')
                        this.login();
                    } else {
                        t.MIX_alert(-1, "Please fill out all the fields", null, null);
                    }

                    //if not valid, errors will be automatically displayed
                })
			},
        }
    }
</script>

<style scoped>
</style>

